import { useEffect, useRef } from 'react'
import {
  Content,
  ContentDescription,
  ContentDescriptionText,
  ContentDescriptionTextLink,
  ContentDescriptionTitle,
  ContentTitle
} from '../../assets/styles/styles'
import stores from '../../stores/store'

export default function Thanks() {
  const { jsonSelected: lang } = stores.DataLocaleStore()
  const { hideHeader, setHideHeader } = stores.DataHideHeaderStore()
  const listRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleWheel = (event: WheelEvent) => {
      const element = listRef.current
      if (!element) return

      const isAtTop = element.scrollTop === 0
      const isAtBottom =
        element.scrollHeight - element.scrollTop === element.clientHeight

      if ((event.deltaY > 0 && isAtBottom) || (event.deltaY < 0 && isAtTop)) {
        setHideHeader(event.deltaY > 0)
      }
    }

    const element = listRef.current
    element?.addEventListener('wheel', handleWheel)

    return () => {
      element?.removeEventListener('wheel', handleWheel)
    }
  }, [])

  return (
    <>
      <Content ref={listRef} $hideHeader={hideHeader}>
        <ContentTitle>{lang.thanks.title}</ContentTitle>

        <ContentDescription>
          <ContentDescriptionText>
            {lang.thanks.description}
          </ContentDescriptionText>
          <ContentDescriptionText>
            {lang.thanks.description2}
          </ContentDescriptionText>
          <br />
          <ContentDescriptionText>
            {lang.thanks.description3}
          </ContentDescriptionText>
          <br />
          <ContentDescriptionText>
            <ContentDescriptionTextLink href="https://www.procob.com/">
              {lang.thanks.link}
            </ContentDescriptionTextLink>
            {lang.thanks.description4}
          </ContentDescriptionText>
          <br />
          <ContentDescriptionText>
            {lang.thanks.description5}
          </ContentDescriptionText>
        </ContentDescription>
      </Content>
    </>
  )
}
